import * as types from '../constants/AuthActionTypes';
import _ from 'lodash';

const initState = {
  user: {},
}

const authreducer = (state = initState, action={}) => {
  switch (action.type) {
    case types.AUTH_SET_USER:
      let {user, isAuthenticated, email_verified} = action;
      user.fullName = `${user.given_name} ${user.family_name}`
      user.initials = `${user.given_name[0].toUpperCase()}${user.family_name[0].toUpperCase()}`
      return _.assign({},state,{user, isAuthenticated, email_verified})
    default:
      return state
  }
}

export default authreducer
